import React, { useRef } from 'react';
import { useGSAP } from '@gsap/react';
import gsap from 'gsap';
import gradientAbstract from '../assets/images/sl_122221_47450_06.jpg';
import { handleScroll } from './Navbar';

const Hero = () => {
  const containerRef = useRef(null);

  useGSAP(() => {
    const tl = gsap.timeline({ delay: 0.2 });
    tl.from('.hero-title', {
      y: 60,
      autoAlpha: 0,
      duration: 1,
      ease: 'power3.out',
    })
      .from('.hero-text', {
        y: 40,
        autoAlpha: 0,
        duration: 0.8,
        ease: 'power2.out',
      }, '-=0.5')
      .from('.hero-btn', {
        y: 20,
        autoAlpha: 0,
        scale: 0.9,
        duration: 0.6,
        ease: 'back.out(1.7)',
      }, '-=0.4');
  }, { scope: containerRef });

  return (
    <section
      ref={containerRef}
      className="relative h-screen bg-cover bg-center"
      style={{ backgroundImage: `url(${gradientAbstract})` }}
    >
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 to-black/20" />
      <div className="relative z-10 flex flex-col items-end justify-center h-full max-w-4xl mx-auto px-6 text-white text-right">
        <h1 className="hero-title text-5xl md:text-6xl font-extrabold mb-6 leading-tight">
          איך לבלוט בתהליך הגיוס
        </h1>
        <p className="hero-text text-xl md:text-2xl mb-8 max-w-xl leading-relaxed text-white/90">
          אני כאן כדי לעזור לכם להשיג את המטרות המקצועיות שלכם ולהבליט את היכולות שלכם בצורה האפקטיבית ביותר
        </p>
        <button
          onClick={() => handleScroll('contact')}
          className="hero-btn px-8 py-3 bg-white text-black font-semibold rounded-full hover:bg-pink-100 transition-colors duration-200 shadow-lg"
        >
          צור קשר
        </button>
      </div>
    </section>
  );
};

export default Hero;
